import { FreshwatchRegisterMessage } from '../../../../customized/fresh-watch/components/auth/Login/RegisterMessage/FreshwatchRegisterMessage';
import { ToggleComponent } from '../../../../featureToggle';
import { RegisterMessage } from './RegisterMessage';

export default ToggleComponent(RegisterMessage, {
  styledComponentsVariants: {
    'fresh-watch': FreshwatchRegisterMessage,
  },
});
